import { EpsgCode } from "../../constants/epsgCode";
import { ICoords } from "../../redux/modules/flightMarkers/flightMarkersReducer";
import { ISRS } from "../../apiFacades/csu/site";
import { getProj4 } from "./getProj4";

export const convertGlobalToWgs84Coords = (
  globalCoords: ICoords,
  srs: ISRS,
): ICoords => {
  if (!srs.isAssumed && srs.globalSrs.epsg === EpsgCode.Wgs84) {
    return globalCoords;
  }
  if (srs.isAssumed && srs.assumedSrs.intermediateSrsEpsg === EpsgCode.Wgs84) {
    return globalCoords;
  }

  const globalProjection = srs.isAssumed
    ? srs.assumedSrs.intermediateSrsProj4
    : srs.globalSrs.proj4;

  return getProj4()(globalProjection, EpsgCode.Wgs84, { ...globalCoords });
};
